export const CURRENT_CONFIG = {
	// license
	appId: "168028", // You need to go to the development website to apply.
	appKey: "3ef2fbdf901bd65fe06b85c38d0448b", // You need to go to the development website to apply.
	appLicense:
		"NPqQUHfnsLbYShfVXoKd/Cd/T2fANYBpY6b3z/Pt9Mj2DaPp8OXGYdin9cKOXPBKYcLs1mmPEP3vtTqZnjh6ViE/bs2fBxhW1ohbauHtwvu1jqAdflEKo4oY+v42mweyDxa6Sa0YndkE2ut1a9y9ouqtSJFFKa4iPEkF8CiqpOI=", // You need to go to the development website to apply.

	// http
	baseURL: "https://demoapi.hellogeo.world/", // API runs on host port 6789
	websocketURL: "wss://demoapi.hellogeo.world/api/v1/ws",
	// livestreaming
	// RTMP  Note: This IP is the address of the streaming server. If you want to see livestream on web page, you need to convert the RTMP stream to WebRTC stream.
	rtmpURL: "rtmp://stream.hellogeo.world/live/", // Example: 'rtmp://192.168.1.1/live/'
	// GB28181 Note:If you don't know what these parameters mean, you can go to Pilot2 and select the GB28181 page in the cloud platform. Where the parameters same as these parameters.
	gbServerIp: "srs-server",
	gbServerPort: "5060",
	gbServerId: "34020000002000000001",
	gbAgentId: "34020000001320000001",
	gbPassword: "123456",
	gbAgentPort: "10080",
	gbAgentChannel: "34020000001320000001001",
	// RTSP
	rtspUserName: "admin",
	rtspPassword: "pass",
	rtspPort: "8554",
	// Agora
	agoraAPPID: "003497c0dca64bf9ba59ab292130e167",
	agoraToken:
		"007eJxTYJjykM+8Xfr4DVtXA585zDc3vE+5fE2vMa3z3rsDVVom63wUGAwMjE0szZMNUpITzUyS0iyTEk0tE5OMLI0MjQ1SDc3MFQNuZSjeZcyMzq5nZmRgZGABYhBgApPMYJIFTHIxpKfmJ+fn5ibmpTAwAAAxDCF2",
	agoraChannel: "geocommand",

	// map - OpenStreetMap configuration (no API key needed!)
	osmTileServer: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
	osmAttribution: "© OpenStreetMap contributors",
};
